var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],ref:'id_' + _vm.plot_id,staticClass:"mt-2 capitalization__scatter-plot",style:(_vm.is_window ? { height : 'calc(100% - 2.125rem - 1.5rem)' } : { height : '100%' }),attrs:{"id":'id_' + _vm.plot_id},on:{"resize":_vm.refresh}})
}
var staticRenderFns = []

export { render, staticRenderFns }